// css文件，需在引入App 之前
import "@/assets/styles/index.less";

import "@/window.js"; // TODO：必须放在项目前面运行
import dsh, { https } from "bri-vtools";

import Vue from "vue";
import App from "./App.vue";
import "@/components/index.js"; // 全局组件
import "@/data/index.js"; // 挂载在prototype的数据
import "@/global/index.js"; // 全局的东西

import store from "@/store/index.js";
import router from "@/router/index.js";

/* 接口工具的配置 -请求状态，响应状态 */
const axios = https.axios;
axios.interceptors.request.use(function (configParam) {
    // 在请求头中添加token
    configParam.headers.authtoken = window.localStorage.getItem("authtoken");
    return configParam;
}, function (error) {
    return Promise.reject(error);
});
axios.interceptors.response.use(response => {
    return response;
});

// 安装核心工具
Vue.use(dsh);

// 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = false;
export default new Vue({
    el: "#app",
    store,
    router,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js